export default __webpack_public_path__ + "static/media/Roboto-Black.0c21e911.ttf";